<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-ticket mr-2" />Adjustment Barcode</h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="No. Faktur PGI">
                        <b-form-input v-model="filter.noFaktur" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="IMEI / SN">
                        <b-form-input v-model="filter.imeiSn" maxlength="100" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group label="Office">
                        <multiselect v-model="filter.office"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optOffice"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Jenis Barang">
                        <multiselect v-model="filter.kind" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optKind" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Merk Barang">
                        <multiselect v-model="filter.brand" label="name" track-by="id" :internal-search="true" :options="optBrand" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Tipe Barang">
                        <multiselect v-model="filter.type" label="name" track-by="id" :internal-search="true" :options="optType" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="text-right">
                    <b-form-group>
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                        <b-button v-if="isAllowedToMassAdjust" class="ml-2" variant="dark" @click="prepareMassAdjust">
                            <i class="fa fa-calculator mr-2" />Hitung Semua
                        </b-button>
                        <b-button class="ml-2" variant="dark" @click="prepareDownload()">
                            <i class="fa fa-download mr-2" />Download Excel
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data barang yang butuh adjustment barcode.
                </template>
                <template v-slot:cell(item)="row">
                    {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}<br />
                        {{ row.item.warehouse }} - {{ row.item.office }}
                    </div>
                </template>
                <template v-slot:cell(identifier)="row">
                    {{ row.item.no_faktur }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}
                    </div>
                </template>
                <template v-slot:cell(basePrice)="row">
                    Rp. {{ $helper.formatThousand(row.item.base_price) }}
                    <div class="text-muted small">
                        <!-- Harga Jual: Rp. {{ $helper.formatThousand(row.item.final_price) }} -->
                        <!-- Harga Jual: Rp. {{ $helper.formatThousand(row.item.final_price_after_adj) }} -->
                        Harga Jual: Rp. {{ $helper.formatThousand(row.item.final_price_after_segment) }}
                    </div>
                </template>
                <template v-slot:cell(currentPrice)="row">
                    <div v-if="row.item.year == null">Rp. {{ $helper.formatThousand(row.item.type_price) }}</div>
                    <div v-else>Rp. {{ $helper.formatThousand(row.item.year_price) }}</div>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Hitung Ulang" @click="showModal(row.item)">
                        <i class="fa fa-fw fa-refresh" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-process" title="Hitung dan Cetak Ulang" size="md" no-close-on-backdrop no-close-on-esc hide-footer :hide-header-close="isSubmitting || phase == 2">
            <div v-if="phase == 1">
                Hitung ulang harga barang ini berdasarkan harga dasar terbaru?
                <div class="mt-4 text-right">
                    <b-button variant="primary" :disabled="isSubmitting" @click="execAdjust">
                        {{ isSubmitting ? "Menghitung ulang..." : "Hitung Ulang" }}
                    </b-button>
                </div>
            </div>
            <div v-else-if="phase == 2">
                Harga barang berhasil dihitung ulang. Silahkan cetak barcode terbaru.
                <br /><br />
                <iframe :src="getBarcodeLink()" height="300px" width="100%" />
                <div class="mt-4">
                    <b-row>
                        <b-col md="6">
                            <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                                Print {{ barcodePage == '1' ? 'Barcode tanpa harga' : 'Barcode ada harga' }}
                            </b-button>
                        </b-col>
                        <b-col md="6" class="text-right">
                            <b-button variant="primary" @click="closeModal">
                                Selesai
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </b-modal>
        <b-modal id="m-download" title="Download Excel Adjustment Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="downloadStatus == 0">
                Menyiapkan laporan, mohon menunggu...
            </div>
            <div v-else-if="downloadStatus == -1">
                Gagal menyiapkan excel. Silahkan coba lagi!
            </div>
            <div v-else>
                Excel sudah siap. Tekan tombol dibawah ini untuk download Excel.

                <div class="mt-2">
                    <a :href="$BASE_FILE_PATH + path" download>
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" />Download Excel
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
        <b-modal id="m-mass-adjust" title="Hitung Ulang" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="!selectCount">
                Hitung ulang sejumlah {{ totalRows }} barang berdasarkan harga dasar terbaru?
            </div>
            <div v-else>
                <!-- <b-form-group label="Pilih filter Brand:">
                    <b-form-select v-model="adjust.brand" :options="adjust.optFilterBrand" />
                </b-form-group>
                <b-form-group label="Pilih filter Tipe Barang:">
                    <b-form-select v-model="adjust.type" :options="adjust.optFilterType" />
                </b-form-group> -->
                <b-form-group label="Jumlah barang untuk diproses:" :description="'Dapat menghitung ulang sebanyak 1 - ' + totalRows + ' barang.'">
                    <b-input-group>
                        <b-form-input
                            :value="adjustCount"
                            @input="adjustCount = parseNumber($event)"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
                        <!-- <b-input-group-append>
                            <b-button variant="outline-primary" @click="maxAdjustCount">Semua</b-button>
                        </b-input-group-append> -->
                    </b-input-group>
                </b-form-group>
            </div>
            <b-row class="mt-3">
                <b-col md="6">
                    <b-button variant="dark" :disabled="isSubmitting" @click="toggleSelectCount">
                        {{ selectCount ? "Hitung Semua" : "Pilih Barang" }}
                    </b-button>
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button class="ml-2" variant="primary" :disabled="isSubmitting" @click="execMassAdjust">
                        {{ isSubmitting ? "Menghitung ulang..." : "Hitung" }}
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal id="m-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header-close>
            Harga barang berhasil dihitung ulang. Silahkan cetak barcode terbaru.
            <br /><br />
            <iframe :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodePage == '1' ? 'Barcode tanpa harga' : 'Barcode ada harga' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="closeModalBarcode">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="m-mass-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header-close>
            Harga barang berhasil dihitung ulang. Silahkan cetak barcode terbaru.
            <br /><br />
            <iframe :src="getBarcodeMassLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeMassType">
                            Print {{ barcodeMassType == 'barcode' ? 'Kerusakan' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="closeModalBarcode">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import EnumPermissions from "@/shared/enum-permissions";

export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,
            selectCount: false,
            adjustCount: "",

            phase: 1, // 1: Konfirmasi, 2: Selesai, mau cetak ulang
            downloadStatus: 0, // 0: Pending, 1: Sukses, -1: Gagal
            path: "",

            filter: {
                noFaktur: "",
                imeiSn: "",
                kind: null,
                brand: null,
                type: null,
                office: null,
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "item", label: "Barang", sortable: "true" },
                { key: "identifier", label: "No. Faktur PGI & IMEI / SN", sortable: "true" },
                { key: "basePrice", label: "Harga Approval", sortable: "true" },
                { key: "currentPrice", label: "Harga Dasar Sekarang", sortable: "true" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            barcodeLink: "",
            barcodeLinkDamage: "",
            barcodeMassLink: "",
            barcodeMassLinkDamage: "",

            barcodePage: '1',
            barcodeMassType: 'barcode',
            barcodeToggleCooldown: false,

            optOffice: [],
            optKind: [],
            optBrand: [],
            optType: [],

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getOffices = this.$axios.get("master/offices").then(res => {
                this.optOffice = res.data.data
            })

            let getKinds = this.$axios.get("master/kinds").then(res => {
                this.optKind = res.data.data;
            })

            Promise.all([getItems, getOffices, getKinds]).then(() => {
                this.initStatus = 1
            })
            .catch(() => {
                this.initStatus = -1
            })

        },

        showModal(item) {
            this.activeItem = item
            this.$bvModal.show("m-process")
        },

        closeModal() {

            this.$bvModal.hide("m-process")
            this.phase = 1
            this.getItems()

        },

        closeModalBarcode() {

            this.$bvModal.hide("m-barcode")
            this.$bvModal.hide("m-mass-barcode")
            this.getItems()

        },

        getBarcodeLink() {
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}?page=${this.barcodePage}`
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if(this.barcodePage == '1') this.barcodePage = '2'
            else this.barcodePage = '1'
            setTimeout(function(){
                this.barcodeToggleCooldown = false
            }.bind(this),2000);
        },

        execAdjust() {

            this.isSubmitting = true
            let payload = {
                id: this.activeItem.id
            }

            this.$axios.post("barcode-adjustment/adjust", payload).then(res => {
                this.barcodeLink = res.data.data.link
                this.barcodeLinkDamage = res.data.data.linkDamage
                this.phase = 2
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        prepareDownload() {

            this.downloadStatus = 0
            this.$bvModal.show("m-download")

            this.$axios.get("barcode-adjustment/download").then(res => {

                this.path = res.data.data.path
                this.downloadStatus = 1

            })
            .catch(error => {
                this.downloadStatus = -1
                this.$helper.parseError(this, error)
            })

        },

        toggleSelectCount() {
            this.selectCount = !this.selectCount
            if(this.selectCount) this.adjustCount = 1
            else this.adjustCount = this.totalRows
        },

        maxAdjustCount() {
            if(this.selectCount) this.adjustCount = this.totalRows
        },

        prepareMassAdjust() {

            this.selectCount = false
            this.adjustCount = this.totalRows
            this.$bvModal.show("m-mass-adjust")

        },

        getBarcodeMassLink() {
            if(this.barcodeMassType == 'barcode'){
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeMassLink}`
            }
            else{
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeMassLinkDamage}`
            }
        },

        toggleBarcodeMassType() {
            this.barcodeToggleCooldown = true
            if(this.barcodeMassType == 'barcode') this.barcodeMassType = 'damage'
            else this.barcodeMassType = 'barcode'
            setTimeout(function(){
                this.barcodeToggleCooldown = false
            }.bind(this),2000);
        },

        execMassAdjust() {

            let isConfirmed = confirm("Jalankan proses hitung ini? Proses tidak dapat dibatalkan!")
            if(!isConfirmed) return

            this.isSubmitting = true

            let payload = {
                count: this.adjustCount,
            }
            if(!this.$helper.isBlank(this.filter.noFaktur)) {
                payload["filterNoFaktur"] = this.filter.noFaktur
            }

            if(!this.$helper.isBlank(this.filter.imeiSn)) {
                payload["filterImeiSn"] = this.filter.imeiSn
            }

            if(this.filter.kind != null) {
                payload["filterKind"] = this.filter.kind.id
            }

            if(this.filter.brand != null) {
                payload["filterBrand"] = this.filter.brand.id
            }

            if(this.filter.type != null) {
                payload["filterTipe"] = this.filter.type.id
            }

            if(this.filter.office != null) {
                payload["filterOffice"] = this.filter.office.id
            }

            if(!this.$helper.isBlank(this.sortBy)) {
                payload["sortBy"] = this.sortBy
                payload["sortDesc"] = this.sortDesc
            }

            this.$axios.post("barcode-adjustment/mass-adjust", payload).then(res => {

                this.$bvModal.hide("m-mass-adjust")
                this.$helper.toastSuccess(this, "Harga barang berhasil dihitung ulang!")

                this.barcodeMassLink = res.data.data.link
                this.barcodeMassLinkDamage = res.data.data.linkDamage


                this.$bvModal.show("m-mass-barcode")

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if(!this.$helper.isBlank(this.filter.imeiSn)) {
                param += "&filterImeiSn=" + this.filter.imeiSn
            }

            if(this.filter.kind != null) {
                param += "&filterKind=" + this.filter.kind.id
            }

            if(this.filter.brand != null) {
                param += "&filterBrand=" + this.filter.brand.id
            }

            if(this.filter.type != null) {
                param += "&filterTipe=" + this.filter.type.id
            }

            if(this.filter.office != null) {
                param += "&filterOffice=" + this.filter.office.id
            }

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("barcode-adjustment" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                this.adjustCount = this.totalRows
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        parseNumber(data){
        return data.toString().replace(/[^0-9]/g, '')
        }

    },
    computed: {
        isAllowedToMassAdjust() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.ADJUSTMENT_BARCODE_HITUNG_ULANG.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            );
        }
    },
    watch: {
        "filter.kind": function (newVal) {
            this.filter.brand = null
            this.optBrand = []
            this.filter.type = null
            this.optType = []

            if (newVal != null) {
                this.$axios.get("master/brands/" + this.filter.kind.id).then(res => {
                    this.optBrand = res.data.data
                })
            }
        },
        "filter.brand": function (newVal) {
            this.filter.type = null
            this.optType = []

            if (newVal != null) {
                this.$axios.get("master/types/" + this.filter.brand.id).then(res => {
                    this.optType = res.data.data
                })
            }
        }
    },

    created() {
        this.init()
    }
}
</script>
